import { useTheme } from '@emotion/react';
import React from 'react';

import { ResponsiveNavigator } from './ResponsiveNavigator';

export const RootNavigator: React.FC = () => {
  const { navigatorTheme } = useTheme();
  return <ResponsiveNavigator theme={navigatorTheme} />;
};
